"use client";

import { usePathname } from "next/navigation";
import { SupportChat } from "./SupportChat";

// Whitelist — widget shows only on user-product surfaces. Outside this list:
// blog (SEO traffic, not customers), legal pages, auth flow, admin (founder
// doesn't chat with himself), public artifact viewer for non-owners (handled
// implicitly — those visitors are usually anonymous, gate filters them).
const ALLOWED_PREFIXES = ["/dashboard", "/niche", "/plan", "/brand", "/settings", "/pricing"];

function shouldShowChat(pathname: string): boolean {
  if (pathname === "/") return true; // landing
  return ALLOWED_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export function SupportChatRouter() {
  const pathname = usePathname();
  if (!shouldShowChat(pathname)) return null;
  return <SupportChat />;
}
